var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('notifications',{attrs:{"position":"bottom right"}}),_c('v-overlay',{attrs:{"value":_vm.$store.state.Loading.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }